import { MAP_COLOR, THEME_PALETTE_SPECIAL_TEXT_COLOR } from "ui/model"
import {
  DEFAULT_IMPRESSION_EXTRUSION_VALUE,
  DEFAULT_MAP_POPUP_HEIGHT_IN_PX,
  DEFAULT_MAP_POPUP_WIDTH_IN_PX,
  IMapInfo,
  IMapServiceState,
  SCREEN_IMAGE_10_ID
} from "./model"

export const state: IMapServiceState = {
  featuresByType: {
    coordinates: [],
    shapes: [],
    screens: [],
    impressions: [],
    intersectGeoTarget: null
  },
  nextShapeId: 0,
  nextFeatureId: 0,
  inventory: {
    containerId: "",
    isRefreshing: false,
    map: null,
    scaleControl: null,
    width: DEFAULT_MAP_POPUP_WIDTH_IN_PX,
    height: DEFAULT_MAP_POPUP_HEIGHT_IN_PX,
    isMaximized: false,
    initialPositionInPixel: {
      x: document.body.offsetWidth - DEFAULT_MAP_POPUP_WIDTH_IN_PX - 16,
      y: 16
    },
    mapInfo: getDefaultMapInfo(),
    popup: undefined as any,
    screensStyleTextColor: THEME_PALETTE_SPECIAL_TEXT_COLOR,
    screensStyleCircleRadius: 15,
    screensStyleCircleColor: MAP_COLOR,
    refreshDataOnMapOpening: true,
    currentRequest: 0,
    screensStyleIconImage: SCREEN_IMAGE_10_ID,
    screensStyleExtrusion: DEFAULT_IMPRESSION_EXTRUSION_VALUE,
    isMapOpening: true
  },
  geoTargets: {
    containerId: "",
    map: null,
    scaleControl: null,
    tempCoordinateFeatures: null,
    mapInfo: getDefaultMapInfo(),
    coordinateLayersReady: false
  }
}

export function getDefaultMapInfo(): IMapInfo {
  return {
    center: { x: -94.51634841254452, y: 38.67652743081703 },
    zoom: 3.261571258371734,
    boundaryBox: {
      ne: { x: -62.110452898595085, y: 51.07299413471105 },
      sw: { x: -126.92224392649533, y: 23.698146045794758 }
    },
    bearing: 0,
    pitch: 0,
    scale: 22755773.380920403
  }
}

if (IS_NOT_PROD) {
  const win = window as any
  win.mapState = state
}
